import { apiGenerator } from '../../../framework/apis/apiGenerator';
import { env } from '../../../framework/utils/EnvUtils';
import { FileKind } from '../../models/gen/fileKind';
import { FileUtils } from '../../utils/FileUtils';
import { useGenericMutation } from '../../utils/ReactQueryUtils';
import { queryOptions } from './base';

export const ATTACHED_FILE_CONTEXT_NAMES = {
  GET_ATTACHED_FILE_DOWNLOAD: 'downloadAttachedFile',
  GET_ATTACHED_FILE: 'getAttachedFile',
  POST_ATTACHED_FILE_PREVIEW: 'previewAttachedFile',
} as const;

const apis = apiGenerator();

export type DownloadAttachedFileQuery = {
  mode?: FileKind;
  id?: number;
  filename?: string;
};
export type DownloadAttachedResult = { file: Blob; filename: string };

/**
 * GET `/attached-file/download?mode=&id=&filename=`
 *
 * @param param -
 * @returns
 */
export const useGetAttachedFileDownload = () =>
  useGenericMutation(async (param: DownloadAttachedFileQuery) =>
    apis.get<void, DownloadAttachedResult>(FileUtils.toFileDownloadUrl(param), {
      ...queryOptions,
      responseBodyType: 'BLOB',
    })
  );

/**
 * GET `/attached-file?mode=&id=&filename=`
 *
 * @param param -
 * @returns
 */
export const useGetAttachedFile = () =>
  useGenericMutation(async (params: DownloadAttachedFileQuery[]) =>
    Promise.all(
      params.map((param) =>
        apis.get<void, DownloadAttachedResult>(FileUtils.toFileGetUrl(param), {
          ...queryOptions,
          responseBodyType: 'BLOB',
        })
      )
    )
  );

/**
 * POST `/attached-file/preview`
 *
 * @param param -
 * @returns
 */
export const usePostAttachedFilePreview = () =>
  useGenericMutation(async (param: FormData) =>
    apis.post<FormData, DownloadAttachedResult>(
      `${env.BASE_API_ENDPOINT}/attached-file/preview`,
      {
        ...queryOptions,
        data: param,
        responseBodyType: 'BLOB',
        withoutAuthentication: true,
      }
    )
  );
